import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

interface VampMonthControlProps {
  month: string;
  maxMonth: string;
  onChange: (month: string) => void;
}

const shiftMonth = (month: string, by: number): string => dayjs.utc(`${month}-01`).add(by, "month").format("YYYY-MM");

const BUTTON = "flex h-7 w-7 items-center justify-center rounded-lg text-gray-500 hover:bg-gray-100 disabled:text-gray-300 disabled:hover:bg-transparent";

export default function VampMonthControl({ month, maxMonth, onChange }: VampMonthControlProps) {
  return (
    <div className="flex items-center gap-3.5 rounded-[10px] bg-gray-50 px-3.5 py-2.5">
      <div className="flex items-center gap-0.5 rounded-xl border border-gray-200 bg-white p-1">
        <button type="button" aria-label="Previous month" className={BUTTON} onClick={() => onChange(shiftMonth(month, -1))}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M15 18l-6-6 6-6" />
          </svg>
        </button>
        <div className="min-w-[116px] px-3 text-center text-sm font-semibold text-gray-700">{dayjs.utc(`${month}-01`).format("MMMM YYYY")}</div>
        <button
          type="button"
          aria-label="Next month"
          className={BUTTON}
          disabled={month >= maxMonth}
          onClick={() => onChange(shiftMonth(month, 1))}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 18l6-6-6-6" />
          </svg>
        </button>
      </div>
    </div>
  );
}
